import { apiFetch } from "./client";

export function listLeads() {
  return apiFetch("/api/admin/leads");
}

/** Log a lead that came in by phone or text. */
export function createLead(payload) {
  return apiFetch("/api/admin/leads", { method: "POST", body: payload });
}

export function updateLead(leadId, patch) {
  return apiFetch(`/api/admin/leads/${leadId}`, { method: "PATCH", body: patch });
}

/** Spam only — a real lead that didn't book should be marked lost instead. */
export function deleteLead(leadId) {
  return apiFetch(`/api/admin/leads/${leadId}`, { method: "DELETE" });
}

/** Find or create the customer record for a lead, ready to quote. */
export function customerForLead(leadId) {
  return apiFetch(`/api/admin/leads/${leadId}/customer`, { method: "POST", body: {} });
}

/** Everything said with one lead: {lead, items, open_draft_id, ai_enabled}. */
export function getLeadConversation(leadId) {
  return apiFetch(`/api/admin/leads/${leadId}/conversation`);
}

/** Log a reply, call, text, email or note: {kind, direction: "in"|"out", note}. Returns the conversation. */
export function logLeadTouch(leadId, body) {
  return apiFetch(`/api/admin/leads/${leadId}/touches`, { method: "POST", body });
}

export function deleteLeadTouch(leadId, touchId) {
  return apiFetch(`/api/admin/leads/${leadId}/touches/${touchId}`, { method: "DELETE" });
}

/** Start or stop the no-reply emails for one lead. */
export function leadCampaignAction(leadId, action) {
  return apiFetch(`/api/admin/leads/${leadId}/campaign`, { method: "POST", body: { action } });
}
